import React, { Component } from 'react';
import { Button } from 'carbon-components-react';
import Select from 'react-select';
import Results from '../../../../components/trades/results';
import { getDmService } from '../../../../services/Api';
import { Card, Breadcrumb } from '../../../../components';
import ConfirmRequestClipboard from './ConfirmRequestClipboard';
import ConfirmExchangeClipboard from './ConfimExchangeClipboard';

class ClipboardsTrads extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // typed: '',
      showResults: false,
      dataClerck: {},
      // goExchange: false,
      // clerk: null,
      selectedItemSearch: null,
      optionsCleark: [],
      viewSearch: true,
      viewRequest: false,
      viewExchange: false,
      btnReturn: false,
    };
  }

  componentWillMount() {
    this.searchTrade();
  }


  searchTrade = async () => {
    const urlGet = '/Atendente/BuscaAtendentes/?busca=&tipoAssistente=2';
    try {
      const data = await getDmService(urlGet);
      const arrClearck = data.map(item => ({ id: item.id, label: item.nome }));
      
      this.setState({
        optionsCleark: arrClearck
      });
    } catch (error) {
      console.log(error);
    }
  }

  postRequest = () => {
    this.setState({
      viewSearch: false,
      viewRequest: true,
      viewExchange: false,
      btnReturn: false,
    });
  };

  postExchangeOrder = (/* orderId */) => {
    this.setState({
      // orderId,
      viewSearch: false,
      viewRequest: false,
      viewExchange: true,
      btnReturn: false,
    });
  };

  changeSelected = obj => {
    if (obj) {
      this.setState({ selectedItemSearch: obj, btnReturn: false }, () => {
        this.searchTradeTyped(obj);
      });
    } else {
      this.setState({
        selectedItemSearch: {},
        showResults: false,
      });
    }
  };

  searchCleark = async value => {
    const urlGet = `/Atendente/BuscaAtendentes/?busca=${value}&tipoAssistente=1`;

    const validatValue = value.length === 0 || value.length >= 3;
    if(validatValue){
      try {
        const data = await getDmService(urlGet);
        const list = await data.map(item => ({ id: item.id, label: item.nome }));
        await this.setState({
          optionsCleark: []
        }, () => {
          this.insertList(list)
        });
  
      } catch (error) {
        console.log(error);
      }
    }
  }

  insertList = newList => {
    const {optionsCleark} = this.state;
    console.log("List clearck")
    console.log(optionsCleark);

    this.setState({
      optionsCleark: newList
    })
  }

  returnSearchTrades = () => {
    this.setState({
      viewSearch: true,
      viewRequest: false,
      viewExchange: false,
      btnReturn: true,
    });
  };

  returnRequest = () => {
    this.setState({
      viewSearch: false,
      viewRequest: true,
    });
  };

  clearItens = () => {
    window.location.href = '/trade/pranchetas';
  };

  searchTradeTyped = async obj => {
    const urlGet = `/Atendente/BuscaAtendentes/?busca=${obj.label}&tipoAssistente=2`;
    try {
      const data = await getDmService(urlGet);
      let dataClerck = {}
      for (const item of data) {
        dataClerck = {
          id: item.id,
          name: item.nome,
          codLastRequest: item.codigoUltimoPedido,
          orderId: item.idUltimoPedido,
          codeOrder: item.codigoUltimoPedido,
          dateOrder: item.dataUltimoPedido,
        }
      }
      
    await  this.setState({
        showResults: true,
        cleark: obj,
        dataClerck
      });

    } catch (error) {
      console.log(error)
    }

  }

  render() {
    const {
      dataClerck,
      showResults,
      selectedItemSearch,
      optionsCleark,
      viewSearch,
      viewRequest,
      viewExchange,
      cleark,
      btnReturn,
    } = this.state;

    return (
      <div>
        <Breadcrumb
          title="Pranchetas"
          description="Atendente que é exclusiva do cartão em loja pode ter uma prancheta. Caso tenha uma atendente que se encaixe nesse perfil solicite o material."
          renderLeft={
            !viewSearch && (
              <div
                className="breadcrumb-left-actions pointer"
                onClick={() => this.returnSearchTrades()}
              >
                <svg width="16" height="14" viewBox="0 0 16 14">
                  <path d="M4.044 8.003l4.09 3.905-1.374 1.453-6.763-6.356L6.759.639 8.135 2.09 4.043 6.003h11.954v2H4.044z" />
                </svg>
              </div>
            )
          }
        />
        {viewSearch && (
          <Card className="center-box box-padd">
            <p className="description-option-title ">Atendente</p>
            <p className="description-option-desc">
              Digite o nome da pessoa e confira as ações que você pode efetuar.
            </p>
            <div className="search-clearck">
              <div className="search-typed">
                <span className="warning">Digite as 3 primeiras letras para fazer a pesquisa.</span>
                <Select
                  value={selectedItemSearch}
                  label="Digite o nome do atendente."
                  placeholder="Digite o nome da atendente"
                  options={optionsCleark}
                  onInputChange={e => this.searchCleark(e)}
                  onChange={e => this.changeSelected(e)}
                  className="search-dm"
                />
              </div>
            </div>
            {dataClerck.orderId !== 0 &&
              dataClerck.orderId &&
              showResults && <Results type="pranchetas" order={dataClerck} legend="__" />}
            <div className="bx--row">
              <div className="bx--col-xs-12 v-md-margin buttons-footer-requests">
                {dataClerck.orderId === 0 &&
                  showResults && (
                    <div>
                      <Button onClick={() => this.postRequest()}> Solicitar Prancheta </Button>
                      {btnReturn && (
                        <Button
                          kind="ghost"
                          onClick={() => this.clearItens()}
                          className="h-sm-margin"
                        >
                          {' '}
                          Limpar
                        </Button>
                      )}
                    </div>
                  )}
                {dataClerck.orderId > 0 &&
                  showResults && (
                    <div>
                      <Button onClick={() => this.postExchangeOrder(dataClerck.orderId)}>
                        {' '}
                        Trocar
                        {' '}
                      </Button>
                      {btnReturn && (
                        <Button
                          kind="ghost"
                          onClick={() => this.clearItens()}
                          className="h-sm-margin"
                        >
                          Limpar
                        </Button>
                      )}
                    </div>
                  )}
              </div>
            </div>
          </Card>
        )}
        {viewRequest && (
          <ConfirmRequestClipboard cleark={cleark} returnSearch={this.returnSearchTrades} />
        )}
        {viewExchange && (
          <ConfirmExchangeClipboard
            cleark={cleark}
            orderId={dataClerck.orderId}
            returnSearch={this.returnSearchTrades}
            dateOrder={dataClerck.dateOrder}
          />
        )}
      </div>
    );
  }
}

export default ClipboardsTrads;



// WEBPACK FOOTER //
// ./src/screens/client/trades/clipboards/ClipboardsTrads.jsx